import { gql } from "@apollo/client";

export const GET_ESTADOS_CONTRATO = gql`
query allEstadoEvaluacion {
    allEstadoEvaluacion{
        idEstadoEvaluacion
        codigo
        descripcion
    }
}`;

export const adaptEstadoContrato = (estado) => ({
  id: estado.idEstadoEvaluacion,
  codigo: estado.codigo,
  displayName: estado.descripcion
});

export const adaptEstadosContratoArray = (estados) =>
structuredClone(estados?.allEstadoEvaluacion)?.
map((estado) => adaptEstadoContrato(estado));